import File from "@base/Inputs/File/File"

export default File;
